import React from 'react';
// @ts-ignore
import pdfSomunia from '../assets/images/somunia.png';
// @ts-ignore
import pdfRoom from '../assets/images/room.png';
// @ts-ignore
import pdfTransporter from '../assets/images/transporter.png';
// @ts-ignore
import pdfModisc from '../assets/images/modisc.png';
// @ts-ignore
import pdfTransferEvent from '../assets/images/transferevent.png';
import { logData } from '../types/LogData.ts';
import './FileViewer.css';
import '../index.css';

interface FileViewerProps {
  type: string;
  filename: string;
}

const FileViewer: React.FC<FileViewerProps> = ({ type, filename }) => {
  if (type === 'txt') {
    const data = logData[filename];
    if (!data) return <div>File not found</div>;

    return (
      <span className="file-viewer-container">
        <span className="file-viewer-header">
          <span className="file-viewer-title message-text">
            <div className='message-text'>タイトル：{data.title}</div>
            <div className='message-text'>日付：{data.date}</div>
            <div className='message-text letter-spacing'>投稿者：{data.author}</div>
            <div className='message-text' style={{ whiteSpace: 'nowrap' }}>映像URL： <a href={data.url} target="_blank" rel="noreferrer" className='message-text' style={{ display: 'inline' }}>{data.url}</a></div>
          </span>
        </span>
        <span className="file-viewer-content message-text">
          概要：<br/>
          {data.content}
        </span>
      </span>
    );
  }

  // PDFタイプのファイルの場合、ファイル名に基づいて適切な画像を表示
  const getPdfImage = () => {
    switch(filename) {
      case 'somuniaの身体について':
        return pdfSomunia;
      case '部屋について':
        return pdfRoom;
      case '転送装置':
        return pdfTransporter;
      case 'MODisc':
        return pdfModisc;
      case '不明なソフトによる転移事象':
        return pdfTransferEvent;
      default:
        return pdfSomunia; // デフォルト画像
    }
  };

  return (
    <div className="file-viewer-container">
      <img 
        src={getPdfImage()} 
        alt={`PDF Preview: ${filename}`} 
        className="file-viewer-image-content"
      />
    </div>
  );
};

export default FileViewer; 